import React from "react";
interface props {
  className?: string;
}

function Icon7({ className }: props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 42 43"
    >
      <circle cx="21" cy="21.059" r="20.5" stroke="#FF752C"></circle>
      <path stroke="#FF752C" d="M14.5 17.5a1 1 0 100-2 1 1 0 000 2z"></path>
      <path
        stroke="#FF752C"
        strokeLinecap="round"
        d="M17.5 15.5h11m-11 2h6"
      ></path>
      <path stroke="#FF752C" d="M14.5 22a1 1 0 100-2 1 1 0 000 2z"></path>
      <path stroke="#FF752C" strokeLinecap="round" d="M17.5 20h8m-8 2h7"></path>
      <path stroke="#FF752C" d="M14.5 26.5a1 1 0 100-2 1 1 0 000 2z"></path>
      <path
        stroke="#FF752C"
        strokeLinecap="round"
        d="M17.5 24.5H27m-9.5 2h4"
      ></path>
    </svg>
  );
}

export default Icon7;
